import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from "@angular/router";
import { BackendRights } from "@ramudden/models/backend-rights";
import { Rights } from "@ramudden/models/rights";
import { Roles } from "@ramudden/models/user";
import { AuthenticationService } from "../services/authentication.service";
import { GlobalStateService } from "../services/global-state.service";

export const authorizationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const globalStateService = inject(GlobalStateService);
    const authenticationService = inject(AuthenticationService);

    return checkRights(route, globalStateService.getCurrentRights(), globalStateService.getCurrentRoles());

    function checkRights(route: ActivatedRouteSnapshot, rights: Rights, roles: Roles[]): boolean | UrlTree {
        const expectedRights = route.data?.["rights"] as BackendRights[];
        const expectedRoles = route.data?.["roles"] as Roles[];

        if (!expectedRights && !expectedRoles) {
            return false;
        }

        const navigationAllowed =
            (!expectedRights || expectedRights.some((x) => rights.hasBackendRight(x))) &&
            (!expectedRoles || expectedRoles.all((x) => roles.contains(x)));
        if (navigationAllowed) {
            return true;
        }

        const availableLink = authenticationService.getNavigationLinks(rights).takeFirstOrDefault();
        if (!availableLink) {
            return false;
        }

        return router.parseUrl(availableLink.route);
    }
};
